import type { IDialogManager } from 'components/popup';
import angular from 'angular';

let dialogManager: IDialogManager | any;

function init() {
    if (!dialogManager) {
        let injector: angular.auto.IInjectorService;
        if ((injector = angular.element(document).injector())) {
            dialogManager = injector.get('dialogManager');
        }

        if (!dialogManager) {
            dialogManager = {
                error: (response: any) => {
                    alert(response.message);
                }
            };
        }
    }
}

export const getGeneralHandler = (scope: angular.IScope) => {
    init();
    return response => {
        if (response.message) {
            dialogManager.error(response, scope);
        }
        return Promise.reject(response);
    };
};

export const getDisplayErrorHandler = (scope: angular.IScope, callback: () => void = null) => {
    init();

    return response => {
        if (response && response.message) {
            dialogManager.error(response, scope);
        }
        callback && callback();
        return Promise.reject(response);
    };
};
